/**
 * Options service
 */

import Resource from './resource'

export default new Resource('options')



// WEBPACK FOOTER //
// ./src/libraries/services/options.js